class Footer {
  constructor(configs) {
    this.configs = configs;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(this.configs.selectors.container);
    return container ? {
      container,
      dataAccordionToggleButtons: container.querySelectorAll(this.configs.selectors.dataAccordionToggleButtons),
    } : {};
  }

  _setupEventListeners() {
    for (const dataAccordionToggleButton of this.elements.dataAccordionToggleButtons) {
      dataAccordionToggleButton.addEventListener('click', this._toggleAcordionClick);
    }
  }

  _toggleAcordion (element) {
    if (element.nextElementSibling.style.maxHeight) {
      element.nextElementSibling.style.maxHeight = null;
      element.classList.remove(this.configs.classes.rotate);
    } else {
      element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px";
      element.classList.add(this.configs.classes.rotate);
    }
  }

  _toggleAcordionClick = (e) => {
    this._toggleAcordion(e.currentTarget);
  }
}
